import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ampli } from '../../../../ampli';

export const OAuthLoginResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.search) {
      const urlParams = new URLSearchParams(location.search);

      if (urlParams.has('message')) {
        if (urlParams.get('message') === 'NEED_SIGN_UP') {
          ampli.pvmOauthLoginCompleted({ need_to_sign_up: true });
          sessionStorage.setItem('@signUpToken', `${urlParams.has('signUpToken') && urlParams.get('signUpToken')}`);
          navigate('/join-process/agreement', { replace: true });
        } else if (urlParams.get('message') === 'SUCCESS') {
          ampli.pvmOauthLoginCompleted({ need_to_sign_up: false });
          localStorage.setItem('@accessToken', `${urlParams.has('accessToken') && urlParams.get('accessToken')}`);
          navigate('/after-login', { replace: true });
        }
      }
    }
  }, [location.search, navigate]);

  return <></>;
};
